import { escListener, setCookie, getCookie } from './utils'
import hcSticky from 'hc-sticky'

const filterForm = document.querySelector('.facets form')
const inputElements = filterForm.querySelectorAll('input[type="checkbox"]')

// check current tags and apply to checkboxes
let location = window.location.pathname.replace(/\/+$/, '')

let tags = []

if (location.indexOf('tagged') > -1)
  tags = location.split('tagged/')[1].split('+')

inputElements.forEach((inputElement) => {
  inputElement.addEventListener('change', (e) => {
    const tag = e.target.value
    if (location.indexOf('tagged') > -1) {
      if (location.indexOf(tag) > -1) {
        location = location
          .replace(`+${tag}`, '')
          .replace(`${tag}+`, '')
          .replace(`tagged/${tag}`, '')
      } else location = location + '+' + tag
    } else {
      location = location + '/tagged/' + tag
    }
    window.location.href = location
  })

  tags.length &&
    tags.find((tag) => tag === inputElement.value) !== undefined &&
    inputElement.setAttribute('checked', true)
})

// filters

document.querySelectorAll('.archive-grid').forEach((archiveGrid) => {
  let filtersOpen = false
  let toggleFiltersButton = archiveGrid.querySelector('.toggle-filtering')
  let filtersContainer = archiveGrid.querySelector(
    '.archive-grid__filters-container'
  )

  let closeFilters = () => {
    filtersOpen = false
    archiveGrid.classList.remove('archive-grid__main-container--filters-hidden')
  }

  toggleFiltersButton.addEventListener('click', () => {
    if (filtersOpen) {
      escListener(false)
      closeFilters()
    } else {
      archiveGrid.classList.add('archive-grid__main-container--filters-hidden')
      filtersOpen = true
      escListener(true, closeFilters)
    }
  })

  filtersContainer
    .querySelector('.facets__mobile-close')
    .addEventListener('click', () => {
      escListener(false)
      closeFilters()
    })
})

document.addEventListener('DOMContentLoaded', function () {
  if (window.matchMedia('screen and (min-width: 1024px)').matches) {
    var Sticky = new hcSticky('#main-collection-filters', {
      stickTo: '#main-collection-filters-container',
      top: 130,
    })
  }
})

//Update column count
var el = document.querySelector('.archive-grid__content')

document.querySelector('.three-col').onclick = function () {
  el.classList.remove('archive-grid__content--four-col')
  el.classList.add('archive-grid__content--three-col')
  document.querySelector('.four-col').classList.remove('active')
  document.querySelector('.three-col').classList.add('active')
  setCookie('blog-grid-cols', '3', 1)
}

document.querySelector('.four-col').onclick = function () {
  el.classList.remove('archive-grid__content--three-col')
  el.classList.add('archive-grid__content--four-col')
  document.querySelector('.three-col').classList.remove('active')
  document.querySelector('.four-col').classList.add('active')
  setCookie('blog-grid-cols', '4', 1)
}

document.querySelector('.one-col').onclick = function () {
  el.classList.remove('archive-grid__content--two-col')
  el.classList.add('archive-grid__content--one-col')
  document.querySelector('.two-col').classList.remove('active')
  document.querySelector('.one-col').classList.add('active')
  setCookie('blog-grid-mobile-cols', '1', 1)
}

document.querySelector('.two-col').onclick = function () {
  el.classList.remove('archive-grid__content--one-col')
  el.classList.add('archive-grid__content--two-col')
  document.querySelector('.one-col').classList.remove('active')
  document.querySelector('.two-col').classList.add('active')
  setCookie('blog-grid-mobile-cols', '2', 1)
}

if (getCookie('blog-grid-cols') == 4) {
  el.classList.remove('archive-grid__content--three-col')
  el.classList.add('archive-grid__content--four-col')
  document.querySelector('.three-col').classList.remove('active')
  document.querySelector('.four-col').classList.add('active')
}

if (getCookie('blog-grid-mobile-cols') == 1) {
  el.classList.remove('archive-grid__content--two-col')
  el.classList.add('archive-grid__content--one-col')
  document.querySelector('.two-col').classList.remove('active')
  document.querySelector('.one-col').classList.add('active')
}
